/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonFaucetClaimStatusInfo = {
    STAT: BabylonFaucetClaimStatusInfo.STAT;
    TRXHA: string;
};

export namespace BabylonFaucetClaimStatusInfo {

    export enum STAT {
        PENDING = 'PENDING',
        SUCCESS = 'SUCCESS',
        FAILED_LOW_BALANCE = 'FAILED_LOW_BALANCE',
        FAILED = 'FAILED',
    }


}

